import React from "react";
import girl from "../assets/girll.png";
import text from "../assets/text.png";
import audio from "../assets/audio.png";

const Pipelines: React.FC = () => {
  return (
    <>
      <div
        style={{
          backgroundColor: "#F8FAFC",
          padding: "20px",
          minHeight: "100vh",
        }}
      >
        <h1
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "36px",
            lineHeight: "42px",
            color: "#000000",
            textAlign: "center",
            margin: "20px 0",
          }}
        >
          Our Custom Pipelines
        </h1>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "10px",
              width: "calc(50% - 20px)",
            }}
          >
            <img
              src={girl}
              alt="Girl"
              style={{ marginLeft: "10px", width: "250px", height: "250px" }}
            />
            <p
              style={{
                marginLeft: "20px",
                fontFamily: "'Roboto', sans-serif",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "36px",
                lineHeight: "42px",
                color: "#000000",
                backgroundColor: "#ffffff",
                borderRadius: "25px",
                padding: "10px 20px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              AI Image Generation & Analysis{" "}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "calc(50% - 20px)",
            }}
          >
            <p
              style={{
                fontFamily: "'Roboto', sans-serif",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "36px",
                lineHeight: "42px",
                color: "#000000",
                marginLeft: "60px",
                backgroundColor: "#ffffff",
                borderRadius: "25px",
                padding: "10px 20px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              Audio Analysis & Generation{" "}
            </p>
            <img
              src={audio}
              alt="Audio"
              style={{ marginRight: "20px", width: "250px", height: "250px" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "10px",
              width: "calc(50% - 20px)",
            }}
          >
            <p
              style={{
                fontFamily: "'Roboto', sans-serif",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "36px",
                lineHeight: "42px",
                color: "#000000",
                marginRight: "15px",
                backgroundColor: "#ffffff",
                borderRadius: "25px",
                padding: "10px 20px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              Text Analysis & Generation{" "}
            </p>
            <img
              src={text}
              alt="Text"
              style={{ marginRight: "10px", width: "250px", height: "250px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Pipelines;
